/**
 * Client-side logout for shells that do not mount Main
 * (e.g. immigration reports). Clears ephemeral client state then delegates
 * to /logout-confirmation, which handles Amplify session teardown and the
 * Cognito hosted-UI logout redirect.
 */

import { deleteCookie } from "cookies-next";
import { resetAppNavSession } from "@/lib/app-nav-state";

export async function performClientLogout(): Promise<void> {
  if (typeof window === "undefined") return;

  sessionStorage.removeItem("walkthrus");
  sessionStorage.removeItem("idToken");
  sessionStorage.removeItem("accessToken");
  // Drop case/view/timeline mirrors + URL params + history markers so a later
  // login cannot Back/Forward into this session's app state.
  resetAppNavSession(window.location.pathname || "/");
  localStorage.removeItem("lastActivityTime");
  deleteCookie("PdfPageCounts");

  window.location.replace("/logout-confirmation");
}
